import { Splide, SplideSlide } from '@splidejs/react-splide'
import MainHeader from '../components/MainHeader'
import { useLocation, useNavigate } from 'react-router'
import { useContext, useEffect, useState } from 'react'
import useAxiosRequests from '../hooks/useAxiosRequest'
import ExternalRoutes from '../config/ExternalRoutes'
import { MessageContext } from '../context/MessageContext'
import pdfImage from "../img/pdf.png";
import { CircularProgress } from '@mui/material'

export const ImportDocument = () => {
  const { state } = useLocation()
  const { files, name } = state || []
  const navigate = useNavigate()
  const [selectedFiles, setSelectedFiles] = useState([])
  const [previews, setPreviews] = useState([])
  const { showSuccess, showError } = useContext(MessageContext)
  const [disabled, setDisabled] = useState(false);
  const [fileMaxSize, setFileMaxSize] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (files && files.length > 0) {
      setSelectedFiles(files)

      const filePreviews = files.map(file => ({
        name: file.name,
        url: URL.createObjectURL(file),
        type: file.type,
        size: file.size
      }))

      setPreviews(filePreviews)
      const tooBig = files.filter((file) => file.size > 12 * 1024 * 1024);
      setFileMaxSize(tooBig || null);
      
      return () => {
        filePreviews.forEach(preview => URL.revokeObjectURL(preview.url))
      }

      

    } else {
      navigate("/")
    }
  }, [files, navigate])

  const handleDeleteImage = imageToDelete => {
    const updatedFiles = selectedFiles.filter(
      file => file.name !== imageToDelete.name
    )
    setSelectedFiles(updatedFiles)

    const updatedFileMaxSize = fileMaxSize.filter(
      file => file.name !== imageToDelete.name
    );
    setFileMaxSize(updatedFileMaxSize);

    const updatedPreviews = previews.filter(
      preview => preview.name !== imageToDelete.name
    )
    setPreviews(updatedPreviews)

    URL.revokeObjectURL(imageToDelete.url)

    if (updatedFiles.length === 0) {
      navigate('/')
    }
  }

  const { sendRequest } = useAxiosRequests()
  const onHandleSubmit = async () => {
    setDisabled(true);
    setLoading(true);
    try {
      const formData = new FormData()
      selectedFiles.forEach(file => {
        formData.append('files[]', file);
        formData.append('doc_type', name);
      })

      const response = await sendRequest({
        method: 'POST',
        url: ExternalRoutes.document.add,
        body: formData
      })
      if (!response) {
        return
      }
      if (response.status === 'success' && response.message) {
        showSuccess(response.message)
      } else if (response.status !== 'success' && response.message) {
        showError(response.message)
      } else {
        showError('Une erreur inattendue est survenue.')
      }
      navigate('/')
    } catch (error) {
    } finally {
      setDisabled(false);
     setLoading(false);
    }
  }

  return (
    <>
      <MainHeader />
      <div className=''>
        <div className='kl-login-page'>
          <div className='kl-document-title'>
            <h1>Documents</h1>
            <div className='kl-total-docs kl-total-documents'>
              <span>{previews.length > 0 ? previews.length : 0}</span>
            </div>
          </div>
          <span>Confirme l’importation des documents.</span>
        </div>
        <div className='kl-splide-documents'>
          <Splide
            aria-label='My Favorite Images'
            options={{
              arrows: false,
              pagination: false
            }}
          >
            {previews.length > 0 ? (
              <>
                {previews.map((file, key) => {
                  const src = file.type === 'application/pdf' ? pdfImage : file.url;
                  const maxSize = 12 * 1024 * 1024;
                  return (
                    <SplideSlide key={key}>
                      <div className='kl-slice-content-doc'>
                        <div className='kl-splide-image-doc'>
                          <img key={key} src={src} alt={file.name} />
                        </div>
                        <div className='kl-message-import-doc'>
                          {file.size > maxSize && (
                            <div className="text-danger">Le fichier est trop volumineux (maximum 12MB)</div>
                          )}
                          <button onClick={() => handleDeleteImage(file)}>
                            <svg
                              width='24'
                              height='24'
                              viewBox='0 0 24 24'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z'
                                stroke='#292D32'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                              <path
                                d='M9.16992 14.8299L14.8299 9.16992'
                                stroke='#292D32'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                              <path
                                d='M14.8299 14.8299L9.16992 9.16992'
                                stroke='#292D32'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </SplideSlide>)
                })}
              </>
            ) : (
              <></>
            )}
          </Splide>
        </div>

        <div className='kl-button-import-doc'>
          <button
            className='btn btn-primary'
            disabled={disabled || fileMaxSize.length > 0 || previews.length === 0}
            onClick={onHandleSubmit}
          >
          {
            loading ?
            <>
              <CircularProgress size={15} color='inherit' />
              <span className='mx-2'>Importation ...</span>
            </>
            :
             "Importer"
          }
           
          </button>
        </div>
      </div>
    </>
  )
}
